module.exports = __webpack_public_path__ + "static/media/2.af1ddb1f.jpg";